import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { objectify, fetchPost } from '../../utils';

export const fetch = async (query: { ProductId: number; filters: any; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { ProductId, filters, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';
  const lotSerial = (filters.LotSerial == null) ? '' : filters.LotSerial;

  return fetchPost(
    `/InventoryEnquiry/Product/${ProductId}/LotDetails`,
    { ...filters, LotSerial: lotSerial },
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        StockingLotss: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.StockingLotss) {

            return {
              records: result.StockingLotss.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
